var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Timetable',{attrs:{"id":_vm.id,"type":"staff"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }